<template>
    <section v-if="newBizParam">
        
        <!-- 规则1 start-->
        <div class="rule" style="border-top: 1px solid #d9d9d9;padding-top: 16px;margin-top:16px">
            <h5>重复性限制：</h5>
            <el-checkbox @change="changeCheck(1);$emit('changeData',newBizParam)" v-model="newBizParam.monthOrderSumProduct.enabled"></el-checkbox>
            <span class="txt">规则1：同企业所有人同一核算月内，采集同客户同渠道同报货类型<i class="theme-color">{{ queryCode=='FKSXSDD'? '同产品名称同规格/批号同厂家':'同产品名称同规格同厂家' }}</i>的数据最多</span>
            <div
                :class="!newBizParam.monthOrderSumProduct.limitMax && newBizParam.monthOrderSumProduct.enabled && isOpenCheck ? 'red-border' : ''">
                <el-input :disabled="!newBizParam.monthOrderSumProduct.enabled" class="rule-input-box"
                    v-model="newBizParam.monthOrderSumProduct.limitMax" @input="$forceUpdate();$emit('changeData',newBizParam)"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text" :min="1" :maxlength="7"></el-input>
            </div>
            <span class="txt">条</span>
            <p class="tips"
                v-if="!newBizParam.monthOrderSumProduct.limitMax && newBizParam.monthOrderSumProduct.enabled && isOpenCheck">
                请将规则填写完整</p>
        </div>
        <!-- 规则1 end-->
        <!-- 规则2 start-->
        <div class="rule">
            <h5></h5>
            <el-checkbox @change="changeCheck(2);$emit('changeData',newBizParam)" v-model="newBizParam.orderRepeatIntercept"></el-checkbox>
            <span class="txt">规则2：同企业所有人同一天内，采集同客户同渠道同报货类型<i class="theme-color">{{ queryCode=='FKSXSDD'? '同产品名称同规格/批号同厂家':'同产品名称同规格同厂家' }}</i>的数据不可重复</span>
            <el-tooltip class="item" effect="light" placement="top-start">
                <div slot="content">同企业所有人中，同一天采集同客户名称、同渠道（商业公司）、同报货类型、<i class="tips-color">{{ queryCode=='FKSXSDD'? '同产品名称同规格/批号同厂家':'同产品名称同规格同厂家' }}</i>的单据进行拦截提示"您提交了重复的单据，请调整"。</div>
                <i class="el-icon-question" style="color: #606266;"></i>
            </el-tooltip>    
        </div>
        
        <!-- 规则2 end-->
        <!-- 规则3 start-->
        <div class="rule" >
            <h5></h5>
            <el-checkbox @change="changeCheck(3);$emit('changeData',newBizParam)" v-model="newBizParam.orderDayCustomerSameSum.enabled"></el-checkbox>
            <span class="txt">规则3：同企业所有人员同一天内，提交<i class="theme-color">同一家企业客户</i>的频次不可超过</span>
            <div
                :class="!newBizParam.orderDayCustomerSameSum.ruleItemList[0].sumLimitMax && newBizParam.orderDayCustomerSameSum.enabled && isOpenCheck ? 'red-border' : ''">
                <el-input :disabled="!newBizParam.orderDayCustomerSameSum.enabled" class="rule-input-box"
                    v-model="newBizParam.orderDayCustomerSameSum.ruleItemList[0].sumLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text" :min="1" :maxlength="7"></el-input>
            </div>
            <span class="txt">次</span>
            <p class="tips"
                v-if="!newBizParam.orderDayCustomerSameSum.ruleItemList[0].sumLimitMax && newBizParam.orderDayCustomerSameSum.enabled && isOpenCheck">
                请将规则填写完整</p>
        </div>
         <!-- 规则4 start-->
        <template v-if="$route.query.functionCode == 'FKSXSDD'">
            <div class="rule">
                <h5></h5>
                <el-checkbox @change="changeCheck(4);$emit('changeData',newBizParam)" v-model="newBizParam.selectMedProductQtySum.enabled"></el-checkbox>
                <span class="txt">规则4：限制同一人员提交每笔订单的数量上限</span>
            </div>
            <div class="rule-child" v-if="newBizParam.selectMedProductQtySum.enabled">
                <div class="rule" v-for="(item, index) in newBizParam.selectMedProductQtySum.ruleItemList" :key="index">
                    <el-checkbox @change="item.sumLimitMax = null; $forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                    <span class="txt"><i class="theme-color">{{item.orgType}}</i>最多提交<span
                            :class="!item.sumLimitMax && item.enabled && isOpenCheck ? 'red-border txt' : 'txt'"><el-input
                                @input="$forceUpdate();$emit('changeData',newBizParam)" class="rule-input-box" v-model="item.sumLimitMax"
                                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text" :min="1" :maxlength="7"
                                :disabled="!item.enabled"></el-input></span>盒</span>
                    <p class="tips" v-if="!item.sumLimitMax && item.enabled && isOpenCheck">请将规则填写完整</p>
                </div>
            </div>
        </template>
        <!-- 规则2 end-->
    </section>
</template>
  
<script>
export default {
    props: ['bizParam1','queryCode'],
    data() {
        return {
            isOpenCheck: false,
            newBizParam: null

        };
    },
    watch: {
        bizParam1: {
            deep: true,
            handler(newBizParam) {
                if (!this.$route.query.guid&&this.$route.query.type!=3) return
                this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
                this.$forceUpdate();
            }
        }
    },
    created() {
        if (this.$route.query.guid||this.$route.query.type==3) return
        this.newBizParam = this.bizParam1;
        this.changeCheck(0);

    },
    methods: {
        changeCheck(i) {
            //规则3
            if (!this.newBizParam.monthOrderSumProduct.enabled && (i == 1 || i == 0)) {
                this.newBizParam.monthOrderSumProduct = {
                    "enabled": false,
                    "limitMax": null
                }
            }
            if (!this.newBizParam.monthOrderSumCompetitor.enabled && (i == 2 || i == 0)) {
                this.newBizParam.monthOrderSumCompetitor = {
                    "enabled": false,
                    "limitMax": null
                }
            }
            //规则1
            if (!this.newBizParam.orderDayCustomerSameSum.enabled && (i == 3 || i == 0)) {
                let arr=[
                        {
                            "enabled": true,
                            "customerType": "药店",
                            "sumLimitMax": null
                        },
                        
                    ]
                if(this.queryCode=='FKSCGDD'){
                    arr=[
                        {
                            "enabled": true,
                            "customerType": "供应商",
                            "sumLimitMax": null
                        },
                    ]
                }
                this.newBizParam.orderDayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": arr
                }
            }
                //规则4

            if ((!this.newBizParam.selectMedProductQtySum||!this.newBizParam.selectMedProductQtySum.enabled) && (i == 4 || i == 0)&&this.$route.query.functionCode == 'FKSXSDD') {

                    this.newBizParam.selectMedProductQtySum = {
                        "enabled": false,
                        "ruleItemList": [
                            {
                                "enabled": false,
                                "orgType": "医院",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "保健院",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "诊所",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "门诊",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "社区服务中心",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "乡镇卫生院/室",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "民营医院",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "专科疾病防治院/所/站",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "急救中心/站",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "其他基层医疗",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "其他机构",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "未定义类别的",
                                "sumLimitMax": null
                            }
                        ]
                    }
                    console.log(this.newBizParam.selectMedProductQtySum)
                }  
        
            this.$forceUpdate();
        },
        checkResult() {
            this.isOpenCheck = true;
            this.$forceUpdate();
            let { monthOrderSumProduct , orderDayCustomerSameSum,selectMedProductQtySum } = this.newBizParam;
           
            //规则1 校验
            if (monthOrderSumProduct.enabled && !monthOrderSumProduct.limitMax) return;
            console.log('orderDayCustomerSameSum',orderDayCustomerSameSum);
            if (orderDayCustomerSameSum.enabled && !orderDayCustomerSameSum.ruleItemList[0].sumLimitMax) return;
            //规则3 校验
            console.log('orderDayCustomerSameSum',orderDayCustomerSameSum);
            //规则2 校验
            try {
                let count = 0;
                let list = 12;
                if(this.$route.query.functionCode == 'FKSXSDD'){
                    selectMedProductQtySum.ruleItemList.forEach(k => {
                        if (selectMedProductQtySum.enabled && !k.enabled) {
                            count++;
                        }
                        if (count == list) {
                            throw new Error('请至少勾选一个限制规则');
                        }
                        if (k.enabled && !k.sumLimitMax) {
                            throw new Error('');
                        }
                    });
                }
               
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            
            return true;
        }
    }
};
</script>
  
<style scoped>
.rule {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
}

.w260 {
    width: 260px;
}

.w130 {
    width: 130px;
}

.rule-input-box {
    width: 90px;
}

.txt {
    margin: 0 10px;
    /* flex-shrink: 0; */
}

.theme-color {
    color: #4FA1A4;
    font-style: normal;
}
.tips-color{
    color:red;
    font-style: normal;
}
.rule-child {
    padding-left: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #fafafa;
    margin-bottom: 10px;
    margin-left: 140px;
}
.rule-title{
    display: flex;
    flex-shrink: 0;
}

.tips {
    color: red;
    font-size: 12px;
}

.red-border {
    border: 1px solid red;
    border-radius: 4px;
}

.red-border /deep/ .el-input__inner {
    border: 0 none;
}

span {
    display: inline-block;
}
.rule-child .rule:last-child{
    margin-bottom: 0px;
}
.bh-config-title {
  margin-right: 10px;
  width: 126px;
  text-align: left;
}
h5{
    font-size: 14px;
    color: #212212;
    width: 140px;
    text-align: left;
    margin:0;
    flex-shrink: 0;
    font-weight: normal;
}
</style>
  